export default function WebinarBadge({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <span className="h-fit bg-gradient-to-br from-gray-50 to-gray-100/50 text-sm items-center gap-2 p-1 px-2 rounded-sm w-fit inline ml-2 -mt-1 whitespace-nowrap border-1	border-primary-200">
      {children}
    </span>
  );
}
